module.exports = __webpack_public_path__ + "img/pr-16.c8a1c6dc.png";